import React, { useState, useContext } from 'react';
import { UserContext } from '../context/UserContextProvider';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Version from '../pages/tools/Version';
import { Link } from 'react-router-dom';

const VALogin = () => {
    const [userCode, setUserCode] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const { getApiConfig, loginUser, setContactAndFacilityName, serverDisplayName } = useContext(UserContext);

    const handleCodeChange = e => {
        setUserCode(e.target.value);
    };

    const handleEmailChange = e => {
        setUserEmail(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        const currentUser = { code: userCode, email: userEmail };
        fetch(getApiConfig('siteTestLogin'), {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                'access-code': userCode,
                'email': userEmail
            }),
        })
        .then(response => response.json())
        .then(data => {
            setLoading(false);
            if (data.response && data.response.includes('SUCCESS')) {
                loginUser(currentUser);
                setContactAndFacilityName(data);
            } else {
                setErrorMessage('There was a problem logging you in - please re-enter your credentials.');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            setLoading(false);
            setErrorMessage('There was a problem logging you in - please try again.');
        });
    };

    return (
        <div className="m-5" style={{ fontWeight: '300' }}>
            <main className="login-form">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header bg-primary text-white">Please use the facility access code and a valid email to log in</div>
                                <div className="card-body">
                                    <Form onSubmit={handleSubmit}>
                                        <div className="form-group row pt-4">
                                            <div className="col-md-8 offset-md-2">
                                                <input
                                                    placeholder="Test Code"
                                                    type="text"
                                                    onChange={handleCodeChange}
                                                    value={userCode}
                                                    id="test_code"
                                                    className="form-control"
                                                    name="test-code"
                                                    required
                                                    autoFocus
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-8 offset-md-2">
                                                <input
                                                    placeholder="Email"
                                                    type="email"
                                                    onChange={handleEmailChange}
                                                    value={userEmail}
                                                    id="user_email"
                                                    className="form-control"
                                                    name="user-email"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-8 offset-md-2">
                                            {loading ? (
                                                <Button variant="primary" disabled>
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />{' '}Loading...
                                                </Button>
                                        ) : (
                                                <div className="d-flex justify-content-end align-items-center">
                                                    <Button data-cy="submit-button" variant="primary" type="submit">
                                                        Sign{'\u00A0'}in
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    </Form>
                                </div>
                            </div>
                            <div className="text-center">
                                <div className="text-danger font-weight-bold font-italic">
                                    {errorMessage || '\u00A0'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            {/* Bottom help text specific to VA login page */}
            <div className="d-flex justify-content-center mt-4 mb-5">
                <div className="card bg-primary text-white d-inline-block">
                    <div className="card-body text-left p-2">
                        <p className="mb-1">Forgot or need your access code?</p>
                        <p className="mb-0">
                            Contact the helpdesk at{' '}
                            <a
                                className="text-white"
                                href="mailto:Helpdesk_EHRSafetyEvalTool@utah.edu?subject=EHR Safety Eval Tool&body=Hello, I need some help with..."
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Helpdesk_EHRSafetyEvalTool@utah.edu
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <Version servername={serverDisplayName} />
        </div>
    );
};

export default VALogin;